module.exports = [{
      plugin: require('/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-site-gatsby/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
